export default __webpack_public_path__ + "locales/ko-KR/SmartBanner.json?hash=3681640eda4ac18778e8d2e33bd31447";